const RECIPIENT_NEXT_ACTIONS = 'RECIPIENT_NEXT_ACTIONS';

export default {
	RECIPIENT_NEXT_ACTIONS
};
